<template>
    <b-card>
        <div id="gantt-chart-canvas" style="width: 100%; background: white;"></div>
        <GanttChart v-if="Object.keys(chartData).length !== 0" :chartData="chartData"/>
  </b-card>
</template>

<script>
import GanttChart from '@/views/charts/GanttChart.vue';

export default {
  mounted() {
    this.drawChart();
  },
  props: {
    chartItems: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      timeDomainString: null,
      projects: [],
      ganttChart: null,
      projectStatus: {
        COST_OVERRUN: 'bar-cost-overrun',
        COST_UNDERRUN: 'bar-cost-underrun',
        PREDICTION: 'bar-prediction',
        FUTURE: 'bar-future'
      },
      chartData: {}

    };
  },
  components: {
    GanttChart
  },
  computed: {

  },
  watch: {},
  methods: {
    formatDate(date) {
      const d = new Date(date);
      let month = (d.getMonth() + 1).toString();
      let day = d.getDate().toString();
      const year = d.getFullYear();
      if (month.length < 2) {
        month = `0${month}`;
      }
      if (day.length < 2) {
        day = `0${day}`;
      }
      return [year, month, day].join('-');
    },
    // used to draw yearly dotted lines for +20 - 20 years
    generateArrayOfYears() {
      const max = new Date().getFullYear() + 20;
      const min = max - 40;
      const years = [];

      for (let i = max; i >= min; i--) {
        years.push(new Date(i, 0, 1));
      }
      return years;
    },
    drawChart() {
      const projectNames = this.chartItems.map((a) => a.name);
      const today = new Date();

      const predictions = this.chartItems.reduce((filtered, obj) => {
        if (obj.start_date && obj.end_date) {
          filtered.push({ ...obj, type: 'PREDICTION' });
        }
        return filtered;
      }, []);

      const allChartItems = this.chartItems.reduce((filtered, obj) => {
        if (obj.first_date && obj.last_date) {
          const classType = (obj.eac <= obj.contract_total) ? 'COST_UNDERRUN' : 'COST_OVERRUN';
          filtered.push({ ...obj, type: classType });
        }
        return filtered;
      }, []);

      const splitProjects = [];
      for (let i = 0; i < allChartItems.length; i++) {
        const project = allChartItems[i];
        if (new Date(project.last_date) > today) { // split project in two
          const pastPart = { ...project };
          pastPart.last_date = this.formatDate(today);
          pastPart.has_future_part = true;

          const futurePart = { ...project };
          if (new Date(project.first_date) < today) {
            futurePart.first_date = this.formatDate(today);
          }
          futurePart.type = 'FUTURE';
          splitProjects.push(pastPart);
          splitProjects.push(futurePart);
          allChartItems.splice(i, 1);

          i--;
        }
      }
      const projects = allChartItems.concat(splitProjects);

      this.timeDomainString = '1year';

      const todayDate = new Date();
      todayDate.setHours(3, 0, 0);

      const newYearArr = this.generateArrayOfYears();

      this.chartData = {
        projectNames: projectNames,
        projectStatus: this.projectStatus,
        predictions: predictions,
        today: todayDate,
        height: this.chartItems.length * 40,
        newYearArr: newYearArr,
        projects
      };
    }
  }
};
</script>

<style>
.chart {
    font-family: Arial, sans-serif;
    font-size: 12px;
}

.axis path,
.axis line {
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
}

.bar {
    fill: #33b5e5;
}

.bar-cost-overrun {
    fill: #e44d57;
}

.bar-cost-underrun {
    fill: #3CB371;
}

.bar-prediction {
    fill: rgba(255, 255, 255, 0.1);
    stroke: black;
    stroke-dasharray: 5;
}

.bar-future {
    fill: lightgray;
}

.year-line {
    fill: rgba(255, 255, 255, 0.1);
    stroke: black;
    stroke-dasharray: 5;
}
</style>
